export const authRoles = {
  SERVICE_PROVIDER_ADMIN: "Service Provider Admin",
  ORGANIZATION_ADMIN: "Organization Admin",
  INSPECTOR: "Inspector",
  EXECUTOR: "Executor",
};
